export function haveSameParentDeckId(
  firstParentDeckId: string | null | undefined,
  secondParentDeckId: string | null | undefined
): boolean {
  return (firstParentDeckId ?? null) === (secondParentDeckId ?? null);
}
